<template>
    <div class="clinictreat_body_main">
        <div class="body_bd_main flex_c_between">
            <div class="treat_left_body" v-if="foldOrExpandPatient">
                <div class="title_body flex_c_between">
                    <div class="flex_c_left">
                        <div class="title_line"></div>
                        <div class="title_span flex_c_left">患者列表</div>
                    </div>
                    <div class="title_body_expand icon_f flex_c_right" @click="foldOrExpandPatientList()">
                        <el-icon><Fold /></el-icon>
                    </div>
                </div>
                <div class="patient_table_search">
                    <div class="table_search_ul flex_c_between">
                        <el-col :span="14">
                            <el-input type="text" v-model="patientQueryParams.name" placeholder="搜索关键字" @keyup.enter="searchPatientList()"></el-input>
                        </el-col>
                        <el-col class="flex_c_right" :span="10">
                            <el-button type="primary" @click="searchPatientList()">查询</el-button>
                            <el-button type="warning" @click="addNewPatientTreat()">开单</el-button>
                        </el-col>
                    </div>
                </div>
                <div class="patient_table_thead">
                    <div class="thead_ul flex_c_left">
                        <div class="tb_li">姓名</div>
                        <div class="tb_li_1">性别</div>
                        <div class="tb_li_2">年龄</div>
                    </div>
                </div>
                <div class="patient_table_body" v-infinite-scroll="loadMorePatient" style="overflow:auto" :infinite-scroll-immediate="false" v-loading="patiantloading" :infinite-scroll-disabled="loadDisabled">
                    <div :class="chooseDppId === item.dppId ? 'tb_ul_act flex_c_left':'tb_ul flex_c_left'"
                         v-for="(item, index) in patientList" :key="index" @click="choosePatients(item)">
                        <div class="tb_li flex_c_left">
                            <span class="mrr10"><el-avatar :src="item.avatar" style="width: 20px;height: 20px"></el-avatar></span>
                            <span>{{ item.name }}</span>
                        </div>
                        <div class="tb_li_1">{{ item.sex === '0'?'男': item.sex === '1'?'女':'未知'}}</div>
                        <div class="tb_li_2">{{ item.age }}岁</div>
                    </div>
                </div>
            </div>
            <div class="left_body_expand" v-if="!foldOrExpandPatient">
                <div class="title_body_expand icon_f flex_c" @click="foldOrExpandPatientList()">
                    <el-icon><Expand /></el-icon>
                </div>
            </div>
            <div :class="foldOrExpandPatient?'treat_right_body':'right_body_expand'" v-loading="loading">
                <!--新增患者开单-->
                <div class="step_con" v-if="treatePage === '1'">
                    <div class="treat_step_con">
                        <!--患者信息-->
                        <div class="right_step_treate">
                            <div class="title_body flex_c_left">
                                <div class="title_line"></div>
                                <div class="title_span flex_c_left">患者基本信息</div>
                            </div>
                            <el-form class="step_floor_con" ref="patientInfoFrom" :model="patientInfo" label-width="80px">
                                <el-row class="el_row_width" :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="姓名" :rules="[{required: true}]">
                                            <div class="width100 posi_rela">
                                                <el-input v-model="patientInfo.name" placeholder="姓名(必填)" clearable @input="queryPatiantListByName"></el-input>
                                                <div class="name_select_con" v-if="nameSelectConShow">
                                                    <div :class="item.isChoose ? 'name_select_li name_select_li_act flex_c_between':'name_select_li flex_c_between'"
                                                         v-for="(item, index) in patientRange" :key="index" @click="sureChoosePatient(item.dppId)">
                                                        <div class="font_w" style="float: left">{{ item.name }}</div>
                                                        <div style="float: right; color: var(--el-text-color-secondary); font-size: 13px;">{{ item.identity }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="性别" :rules="[{required: true}]">
                                            <el-radio-group v-model="patientInfo.sex">
                                                <el-radio label="0">男</el-radio>
                                                <el-radio label="1">女</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row class="el_row_width" :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="联系电话" :rules="[{required: true}]">
                                            <el-input v-model="patientInfo.phoneNumber" placeholder="联系电话(必填)" @change="changePatientPhoneNumber()"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="身份证号" :rules="[{required: true}]">
                                            <el-input v-model="patientInfo.identity" placeholder="身份证号(必填)" @change="changePatientIdentity()"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row class="el_row_width" :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="初诊意见">
                                            <el-input type="textarea" v-model="patientInfo.firstVisitResult" placeholder="初诊意见(必填)"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <div v-if="openMore">
                                    <el-row class="el_row_width" :gutter="20">
                                        <el-col :span="24">
                                            <el-form-item label="常住地">
                                                <el-input v-model="patientInfo.province"
                                                          placeholder="患者常住地(选填)"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el_row_width" :gutter="20">
                                        <el-col :span="24">
                                            <el-form-item label="过敏史">
                                                <el-input v-model="patientInfo.allergyHistory"
                                                          placeholder="过敏史(选填)"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div class="el_row_line_div flex_c_left">
                                    <div class="el_row_line_text" @click="showMore">{{openMore?'点击收起更多字段':'点击展示更多字段'}}</div>
                                </div>

                            </el-form>
                        </div>
                        <div class="right_floor_line"></div>
                        <!--治疗检查项目-->
                        <div ref="stepBody" class="treat_right_floor_con" >
                            <div class="right_floor_body" id="step_one_body">
                                <div class="right_floor">
                                    <div class="title_body flex_c_left">
                                        <div class="title_line"></div>
                                        <div class="title_span flex_c_left">
                                            <span>治疗检查项目</span>
                                            <span class="alert_info_span">*治疗或检查项目为辅助病情诊断和治疗的付费项目，请根据患者具体病情，按需选择检查治疗!</span>
                                        </div>
                                    </div>
                                    <el-form class="step_floor_con" ref="form" :model="treatOrder" label-position="right" label-width="90px">
                                        <el-row class="el_row_width" :gutter="20">
                                            <el-col :span="24">
                                                <el-form-item label="诊疗项目">
                                                    <el-radio-group v-model="treatOrder.projectType" @change="qryTreatmentProgramList">
                                                        <el-radio label="0">检查项目</el-radio>
                                                        <el-radio label="1">治疗项目</el-radio>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row class="el_row_width" :gutter="20">
                                            <el-col :span="24">
                                                <el-form-item label="项目类型">
                                                    <el-select multiple placeholder="请选择项目类型" v-model="treatOrderProjectName">
                                                        <el-option
                                                            v-for="treat in treatItemList"
                                                            :key="treat.itemId"
                                                            :label="treat.itemName"
                                                            :value="treat.itemId"
                                                            :disabled="treat.isChoosed"
                                                        >
                                                            <span style="float: left">{{ treat.itemName }}</span>
                                                            <span style="float: right; color: var(--el-text-color-secondary); font-size: 13px;">
                                                            <span style="font-weight: bold;color: #ff9415;margin-right: 5px">{{ treat.itemDefaultPrice }}</span>元/次</span>
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row class="el_row_width" :gutter="20">
                                            <el-col :span="24">
                                                <el-form-item label="备注">
                                                    <el-input type="textarea" v-model="treatOrder.remark" placeholder="备注(非必填)"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="right_floor_line"></div>
                    <div class="el_action_btn">
                        <el-button type="primary" @click="saveDocPateintProfileInfo('add')">提&nbsp;&nbsp;&nbsp;交</el-button>
                    </div>
                </div>


                <!--历史患者开单-->
                <div class="step_con" v-if="treatePage === '2'">
                    <!--患者信息-->
                    <div class="right_step_treate">
                        <div class="title_body flex_c_left">
                            <div class="title_line"></div>
                            <div class="title_span flex_c_left">患者基本信息</div>
                        </div>
                        <div class="patient_info_bd">
                            <div class="drawer_info_body">
                                <div class="drawer_info_bd">
                                    <el-image class="drawer_info_img" :src="patientInfo.avatarImg"></el-image>
                                    <div class="drawer_info_body">
                                        <div class="drawer_info_line">
                                            <span class="treat_name_font">{{ patientInfo.name }}</span>
                                            <el-tooltip content="点击编辑病例信息" placement="right">
                                                <el-icon class="name_icon mrl20" @click="editBaseInfo">
                                                    <edit/>
                                                </el-icon>
                                            </el-tooltip>
                                        </div>
                                        <div class="drawer_info_line">
                                            <span class="mrr20"><span class="font_gray">性别：</span>{{patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知'}}</span>
                                            <span class="mrr20"><span class="font_gray">年龄：</span>{{patientInfo.age === null ? '--' : patientInfo.age}}岁</span>
                                            <span class="mrr20"><span class="font_gray">地址：</span>{{patientInfo.province === null ? '无' : patientInfo.province}}</span>
                                            <span class="mrr20"><span class="font_gray">联系电话：</span>{{patientInfo.phoneNumber === null ? '无' : patientInfo.phoneNumber}}</span>
                                            <span class="mrr20"><span class="font_gray">身份证号码：</span>
                                            {{patientInfo.identity===null?"无":patientInfo.identity.substr(0,6) + '********' + patientInfo.identity.substr(14, 20)}}
                                            </span>
                                        </div>
                                        <div class="drawer_info_line">
                                            <span class="mrr20"><span class="font_gray">过敏史：</span>{{ patientInfo.allergyHistory === null || patientInfo.allergyHistory === '' || patientInfo.allergyHistory === undefined ? '无' : patientInfo.allergyHistory }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div ref="stepBody" class="treat_right_floor_con2" >
                        <!--检查治疗工单-->
                        <div class="right_floor_body" id="step_one_body">
                            <div class="right_floor">
                                <div class="title_body flex_c_left">
                                    <div class="title_line"></div>
                                    <div class="title_span flex_c_left">
                                        <span>检查治疗工单</span>
                                    </div>
                                </div>
                                <div class="med_table_body">
                                    <div class="width100 flex_c_between">
                                        <!-- 搜索-->
                                        <el-form class="search_con flex_c_left mrt16" :model="treatOrderParams" ref="queryForm" :inline="true"
                                                 label-width="80px">
                                            <el-form-item label="诊疗项目">
                                                <el-select class="treat_select_style" v-model="treatOrderParams.projectType" placeholder="诊疗项目">
                                                    <el-option label="全部" value=""></el-option>
                                                    <el-option label="检查" value="0"></el-option>
                                                    <el-option label="治疗" value="1"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="诊断结果">
                                                <el-input
                                                    v-model="treatOrderParams.diagnosis"
                                                    placeholder="诊断关键字"
                                                    clearable
                                                />
                                            </el-form-item>
                                            <el-form-item label="开单日期">
                                                <el-date-picker
                                                    v-model="dateTime"
                                                    value-format="YYYY-MM-DD HH:mm:ss"
                                                    type="datetimerange"
                                                    range-separator="至"
                                                    start-placeholder="开始日期"
                                                    end-placeholder="结束日期"
                                                    @change="chooseDateTime($event)"
                                                >
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-button class="mrl20" type="primary" icon="Search" @click="getTreatHistoryOrderList">搜索</el-button>
                                            </el-form-item>
                                        </el-form>
                                        <el-button class="mrl20" type="warning" icon="Plus" @click="openAddTreat">开单</el-button>
                                    </div>

                                    <!-- 表格-->
                                    <div class="table_bd" ref="multipleOrderTable">
                                        <div class="thead_div">
                                            <div class="thead_bd_div flex_c_left">
                                                <el-col class="table_td flex_c" :span="1">序号</el-col>
                                                <el-col class="table_td" :span="3">订单编号</el-col>
                                                <el-col class="table_td" :span="4">项目类型</el-col>
                                                <el-col class="table_td" :span="2">执行情况</el-col>
                                                <el-col class="table_td" :span="3">开单时间</el-col>
                                                <el-col class="table_td" :span="2">状态</el-col>
                                                <el-col class="table_td" :span="1">医生</el-col>
                                                <el-col class="table_td" :span="2">诊断</el-col>
                                                <el-col class="table_td" :span="1">金额</el-col>
                                                <el-col class="table_td" :span="1">实收</el-col>
                                                <el-col class="table_td" :span="2">备注</el-col>
                                                <el-col class="table_td" :span="2">操作</el-col>
                                            </div>
                                        </div>
                                        <div class="tbody_div" :style="{height: `${tableHeight}px`}">
                                            <div class="loading_bd flex_c" v-if="tableLoading">
                                                <div class="loading_con flex_c">
                                                    <el-icon class="loading_size is-loading">
                                                        <Loading />
                                                    </el-icon>
                                                    <div class="loading_text">数据加载中</div>
                                                </div>
                                            </div>
                                            <div class="tbody_bd flex_t_col" v-if="tableData.length > 0">
                                                <div class="tbody_line_div" v-for="(item, index) in tableData" :key="index">
                                                    <div class="tbody_line flex_c_left">
                                                        <el-col class="table_td flex_c" :span="1">{{ index + 1 }}</el-col>
                                                        <el-col class="table_td" :span="3">
                                                            <el-tag class="mrr5" size="small" :type="item.projectType === '1' ? 'success':'primary'">{{ item.projectType === '0' ? '检查' : '治疗' }}</el-tag>
                                                            {{ item.orderNumber }}</el-col>
                                                        <el-col class="table_td" :span="4">{{ item.projectName }}</el-col>
                                                        <el-col class="table_td" :span="2">
                                                            <span style="font-size:14px;font-weight: bold;color: #333">{{ item.isExecutedNum }} / {{ item.treatOrderItemList.length }}</span><br/>
                                                            <span style="font-size:12px;color: orangered" v-if="item.orderStatus === '1' && item.isExecutedInfo === '0'">未执行，订单待支付</span>
                                                            <span style="font-size:12px;color: darkgray" v-if="item.orderStatus === '4' && item.isExecutedInfo === '0'">未执行，订单已取消</span>
                                                            <span style="font-size:12px;color: darkorange" v-if="item.orderStatus !== '1' && item.orderStatus !== '4' && item.isExecutedInfo === '0'">订单未开始执行</span>
                                                            <span style="font-size:12px;color: blue" v-if="item.orderStatus !== '1' && item.orderStatus !== '4' && item.isExecutedInfo === '1'">订单共{{ item.treatOrderItemList.length }}项，已执行{{ item.isExecutedNum }}项</span>
                                                            <span style="font-size:12px;color: green" v-if="item.orderStatus !== '1' && item.orderStatus !== '4' && item.isExecutedInfo === '2'">订单已执行完毕</span>
                                                        </el-col>
                                                        <el-col class="table_td" :span="3">{{ item.createTime }}</el-col>
                                                        <el-col class="table_td" :span="2">
                                                            <el-tag class="mrr5" size="small"
                                                                    :type="item.orderStatus === '1' ? 'danger' : item.orderStatus === '2' ? 'warning' : item.orderStatus === '3' ? 'success' : 'info'">
                                                                {{ item.orderStatus === '1' ? '待支付' : item.orderStatus === '2' ? '待执行' : item.orderStatus === '3' ? '已完成' : '已取消' }}</el-tag>
                                                        </el-col>
                                                        <el-col class="table_td" :span="1">{{ item.docName }}</el-col>
                                                        <el-col class="table_td" :span="2">{{ item.diagnosis }}</el-col>
                                                        <el-col class="table_td font_orange" :span="1">￥{{ item.treatPrice }}</el-col>
                                                        <el-col class="table_td font_orange" :span="1">￥{{ item.orderPrice }}</el-col>
                                                        <el-col class="table_td" :span="2">{{ item.remark === null || item.remark === "" || item.remark === undefined ? '无' : item.remark }}</el-col>
                                                        <el-col class="table_td" :span="2">
                                                            <el-button type="primary" size="small" @click="expandRowDetail(item)">详情</el-button>
                                                        </el-col>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tbody_bd flex_c" v-if="tableData.length <= 0">
                                                <el-empty :image-size="100" description="暂无检查治疗工单" />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 分页-->
                                    <div class="table_pagination">
                                        <el-pagination
                                            background
                                            @size-change="handleSizeChange"
                                            @current-change="handleCurrentChange"
                                            :current-page="currentPage"
                                            :page-size="pageNums"
                                            layout="prev, pager, next, total, sizes"
                                            :total="totalCount">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <!--检查治疗单详情-->
    <el-dialog v-model="treatOrderDetailVisible" center :width="treatOrder.orderStatus === '1'?'40%':'52%'">
        <div class="drawer_detail_body" id="printArea">
            <div class="d_height flex_c">知夏中医门诊部{{ treatOrder.projectType === '0' ? '检查单' : '治疗单' }}</div>
            <div class="drawer_detail_bd">
                <div class="drawer_info_body">
                    <div class="drawer_info_line">
                        <span class="treat_name_font mrr20">{{ treatOrder.dppName }}</span>
                        <span class="mrr20"><span class="font_gray">性别：</span>{{treatOrder.dppSex === '0' ? '男' : treatOrder.dppSex === '1' ? '女' : '未知'}}</span>
                        <span class="mrr20"><span class="font_gray">年龄：</span>{{treatOrder.dppAge === null ? '--' : treatOrder.dppAge}}岁</span>
                        <span class="mrr20"><span class="font_gray">联系电话：</span>{{treatOrder.dppPhone === null ? '无' : treatOrder.dppPhone}}</span>
                    </div>
                    <div class="drawer_info_line">
                        <span class="mrr20"><span class="font_gray">身份证号码：</span>{{treatOrder.dppIdentity===null?"--":treatOrder.dppIdentity.substr(0,6) + '********' + treatOrder.dppIdentity.substr(14, 20)}}</span>
                    </div>
                </div>
            </div>
            <div class="drawer_info_line flex_c_between">
                <div class="width100 flex_c_left">
                    <div class="mrr20"><span class="font_gray">订单编号：</span><span style="font-size:14px;font-weight: bold;color: #333">{{ treatOrder.orderNumber }}</span></div>
                    <div>
                        <span class="font_gray">执行情况：</span>
                        <span style="font-size:14px;font-weight: bold;color: #333">{{ treatOrder.isExecutedNum }} / {{ treatOrder.treatOrderItemList.length }}</span>
                        <span style="font-size:12px;color: orangered" v-if="treatOrder.orderStatus === '1' && treatOrder.isExecutedInfo === '0'">（未执行，订单待支付）</span>
                        <span style="font-size:12px;color: darkgray" v-if="treatOrder.orderStatus === '4' && treatOrder.isExecutedInfo === '0'">（未执行，订单已取消）</span>
                        <span style="font-size:12px;color: darkorange" v-if="treatOrder.orderStatus !== '1' && treatOrder.orderStatus !== '4' && treatOrder.isExecutedInfo === '0'">（订单未开始执行）</span>
                        <span style="font-size:12px;color: blue" v-if="treatOrder.orderStatus !== '1' && treatOrder.orderStatus !== '4' && treatOrder.isExecutedInfo === '1'">（订单共{{ treatOrder.treatOrderItemList.length }}项，已执行{{ treatOrder.isExecutedNum }}项）</span>
                        <span style="font-size:12px;color: green" v-if="treatOrder.orderStatus !== '1' && treatOrder.orderStatus !== '4' && treatOrder.isExecutedInfo === '2'">（订单已执行完毕）</span>
                    </div>
                </div>
                <div class="width30 flex_c_right">
                    <span class="font_gray">订单状态：</span>
                    <span style="font-size:14px;font-weight: bold;"
                          :class="treatOrder.orderStatus === '1' ? 'font_red' : treatOrder.orderStatus === '2' ? 'font_gold' : treatOrder.orderStatus === '3' ? 'font_blue' : 'font_gray'">
                        {{ treatOrder.orderStatus === '1' ? '待支付' : treatOrder.orderStatus === '2' ? '待执行' : treatOrder.orderStatus === '3' ? '已完成' : '已取消' }}</span>
                </div>
            </div>
            <div class="mrt10 thead_div">
                <div class="thead_bd_div border_div child_height child_head_bg flex_c_left">
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:5">项目名称</el-col>
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:3">单价</el-col>
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:3">金额</el-col>
                    <el-col class="table_td" :span="3" v-if="treatOrder.orderStatus !== '1'">执行状态</el-col>
                    <el-col class="table_td" :span="5" v-if="treatOrder.orderStatus !== '1'">执行时间</el-col>
                    <el-col class="table_td" :span="3" v-if="treatOrder.orderStatus !== '1'">执行人</el-col>
                    <el-col class="table_td" :span="2" v-if="treatOrder.orderStatus !== '1'">操作</el-col>
                </div>
            </div>
            <div class="tbody_div border_div flex_t_col">
                <div class="tbody_line child_height flex_c_left" v-for="(itm, inx) in treatItemData" :key="inx">
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:5">{{ itm.projectName }}</el-col>
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:3">￥{{ itm.defaultPrice }}</el-col>
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:3">￥{{ itm.orderPrice }}</el-col>
                    <el-col class="table_td" :span="3" v-if="treatOrder.orderStatus !== '1'">
                        <el-tag class="mrr5" size="small" :type="itm.excuteStatus === '1' ? 'success':'danger'">{{ itm.excuteStatus === '1' ? '已执行' : '未执行' }}</el-tag>
                    </el-col>
                    <el-col class="table_td" :span="5" v-if="treatOrder.orderStatus !== '1'">{{ itm.excuteTime === null || itm.excuteTime === "" || itm.excuteTime === undefined ? '---' : itm.excuteTime }}</el-col>
                    <el-col class="table_td" :span="3" v-if="treatOrder.orderStatus !== '1'">{{ itm.excuteBy === null || itm.excuteBy === "" || itm.excuteBy === undefined ? '---' : itm.excuteBy }}</el-col>
                    <el-col class="table_td" :span="2" v-if="treatOrder.orderStatus !== '1'">
                        <el-button v-if="itm.excuteStatus !== '1' && treatOrder.orderStatus === '2'" type="primary" size="small"
                                   @click="executetreatOrderItemFunc(treatOrder.id, itm.toId, itm.projectName)">执行</el-button>
                        <el-button v-if="itm.excuteStatus === '1'" type="info" size="small" @click="executedFunc(itm.projectName)">执行</el-button>
                    </el-col>
                </div>
            </div>
            <div class="width100 mrt10 flex_c_between">
                <div class="detail_left">
                    <div class="drawer_info_line" v-if="treatOrder.remark !== null && treatOrder.remark !== '' && treatOrder.remark !== undefined">
                        <span class="font_gray">订单备注：</span>
                        <span style="font-size:14px;">{{ treatOrder.remark === null || treatOrder.remark === "" || treatOrder.remark === undefined ? '无' : treatOrder.remark }}</span>
                    </div>
                    <div class="drawer_info_line"> <span class="font_gray">开单医生：</span>
                        <span style="font-size:14px;">{{ treatOrder.docName }}</span>
                    </div>
                    <div class="drawer_info_line"> <span class="font_gray">开单时间：</span>
                        <span style="font-size:14px;">{{ treatOrder.createTime }}</span>
                    </div>
                    <div class="drawer_info_line"> <span class="font_gray">开单金额：</span>
                        <span style="font-size:14px;color:red;font-weight: bold">{{ treatOrder.treatPrice }} 元</span>
                    </div>
                    <div class="drawer_info_line"> <span class="font_gray">实收金额：</span>
                        <span style="font-size:14px;color:red;font-weight: bold">{{ treatOrder.orderPrice }} 元</span>
                    </div>
                </div>
                <div class="detail_right flex_c_right flex_t_col">
                    <el-image class="detail_right_img"
                              :src="tencentCosUrl + treatOrder.payQrcode"
                              :zoom-rate="1.2"
                              :max-scale="7"
                              :min-scale="0.2" :hide-on-click-modal="true"
                              :preview-src-list="payCodeList"
                              fit="fill"
                    />
                    <span style="font-size:12px;color:#555;margin-top: 5px">扫码线上支付</span>
                </div>
            </div>
        </div>
        <template #footer>
                <span class="dialog-footer">
                    <el-button type="primary" @click="cancelTreatDetail()">确 定</el-button>
                    <el-button type="warning" v-if="treatOrder.orderStatus === '1'" v-print="printInfoObj">打 印</el-button>
                </span>
        </template>

    </el-dialog>


    <!--编辑患者病例基本信息-->
    <el-dialog
        title="编辑患者基本信息"
        v-model="editBaseInfoVisible"
        width="40%">
        <div class="dislog_con">
            <el-form class="step_floor_con" ref="patientInfoFrom" :model="patientInfo" label-width="80px">
                <el-row class="el_row_width100" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="姓名" :rules="[{required: true}]">
                            <div class="width100 posi_rela">
                                <el-input v-model="patientInfo.name" placeholder="姓名(必填)" @input="queryPatiantListByName"></el-input>
                                <div class="name_select_con" v-if="nameSelectConShow">
                                    <div :class="item.isChoose ? 'name_select_li name_select_li_act flex_c_between':'name_select_li flex_c_between'"
                                         v-for="(item, index) in patientRange" :key="index" @click="sureChoosePatient(item.dppId)">
                                        <div class="font_w" style="float: left">{{ item.name }}</div>
                                        <div style="float: right; color: var(--el-text-color-secondary); font-size: 13px;">{{ item.identity }}</div>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别" :rules="[{required: true}]">
                            <el-radio-group v-model="patientInfo.sex">
                                <el-radio label="0">男</el-radio>
                                <el-radio label="1">女</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="el_row_width100" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="联系电话" :rules="[{required: true}]">
                            <el-input v-model="patientInfo.phoneNumber" placeholder="联系电话(必填)" @change="changePatientPhoneNumber()"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证号" :rules="[{required: true}]">
                            <el-input v-model="patientInfo.identity" placeholder="身份证号(必填)" @change="changePatientIdentity()"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="el_row_width100" :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="初诊意见">
                            <el-input type="textarea" v-model="patientInfo.firstVisitResult" placeholder="初诊意见(选填)"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="el_row_width100" :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="过敏史">
                            <el-input type="textarea" v-model="patientInfo.allergyHistory" placeholder="过敏史(选填)"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="el_row_width" :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="常住地">
                            <el-input v-model="patientInfo.province"
                                      placeholder="患者常住地(选填)"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelEditBaseInfo()">取 消</el-button>
                    <el-button type="primary" @click="saveDocPateintProfileInfo('edit')">保 存</el-button>
                </span>
        </template>

    </el-dialog>



    <!--新增患者的检查治疗项目-->
    <el-dialog
        title="新增检查治疗项目"
        v-model="addTreatVisible"
        width="32%">
        <div class="dislog_con">
            <div class="treat_patient_info_bd">
                <div class="drawer_info_body">
                    <div class="drawer_info_bd">
                        <el-image class="treat_drawer_info_img" :src="patientInfo.avatarImg"></el-image>
                        <div class="treat_drawer_info_body">
                            <div class="drawer_info_line">
                                <span class="treat_name_font">{{ patientInfo.name }}</span>
                            </div>
                            <div class="drawer_info_line">
                                <span class="mrr20"><span class="font_gray">性别：</span>{{
                                        patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知'
                                    }}</span>
                                <span class="mrr20"><span class="font_gray">年龄：</span>{{
                                        patientInfo.age === null ? '--' : patientInfo.age
                                    }}岁</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-form class="step_floor_con" ref="form" :model="treatOrder" label-position="right" label-width="90px">
                <el-row class="el_row_width100" :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="诊疗项目">
                            <el-radio-group v-model="treatOrder.projectType" @change="qryTreatmentProgramList">
                                <el-radio label="0">检查项目</el-radio>
                                <el-radio label="1">治疗项目</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="el_row_width100" :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="项目类型">
                            <el-select multiple placeholder="请选择项目类型" v-model="treatOrderProjectName">
                                <el-option
                                    v-for="treat in treatItemList"
                                    :key="treat.itemId"
                                    :label="treat.itemName"
                                    :value="treat.itemId"
                                    :disabled="treat.isChoosed"
                                >
                                    <span style="float: left">{{ treat.itemName }}</span>
                                    <span style="float: right; color: var(--el-text-color-secondary); font-size: 13px;"><span style="font-weight: bold;color: #ff9415;margin-right: 5px">{{ treat.itemDefaultPrice }}</span>元/次</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="el_row_width100" :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="备注">
                            <el-input type="textarea" v-model="treatOrder.remark" placeholder="备注(非必填)"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelAddTreat()">取 消</el-button>
                    <el-button type="primary" @click="saveAddTreat()">保 存</el-button>
                </span>
        </template>

    </el-dialog>

</template>

<script>
import treatment from "@/assets/scripts/treatment/index";
export default treatment;
</script>

<style scoped>
@import "@/assets/styles/style.scss";
</style>